import {FC, useEffect, useState} from 'react'
import JsonFormatter from 'react-json-formatter'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {getPlugintypeIdByCode} from '../../../../functions/plugintype'
import useAuth from '../../../../hooks/useAuth'
import {GET, POST, PUT} from '../../../../services/api'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

type TemplateResponseType = {
  id: number
  name: string
  parameters: any
  plugintypeId: number
  typeIntegration: 'payment_method' | 'pdv' | 'messenger' | 'others'
}

type ConfigInputsType = {
  name: string
  label: string
  value?: string
}

const EditarPdvContent: FC = () => {
  const navigate = useNavigate()
  const {loginInfo} = useAuth()
  const {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState<string>('')
  const [templates, setTemplates] = useState<TemplateResponseType[]>([])
  const [configInputs, setConfigInputs] = useState<(ConfigInputsType | undefined)[]>([])
  const [templateId, setTemplateId] = useState<number | null>()
  const [jsonContent, setJsonContent] = useState<string | null>(null)

  const jsonStyle = {
    propertyStyle: {color: 'grey'},
    stringStyle: {color: 'white'},
    numberStyle: {color: 'white'},
    booleanStyle: {color: 'white'},
    style: {color: 'white'},
  }

  const getIntegration = async () => {
    try {
      const newTemplates = await getTemplates()
      setLoading(true)
      const integrationRes = await GET(`/pluginconfig/${id}`)
      console.log('Dados do plugin carregados:', integrationRes.data[0])
      setName(integrationRes.data[0].name)
      await changeTemplate(
        integrationRes.data[0].plugintemplateId,
        integrationRes.data[0].content,
        newTemplates
      )
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log('Erro ao carregar plugin:', e)
    }
  }

  const getDto = async (templateId: number) => {
    try {
      if (!loading) setLoading(true)
      const schemaRes = await POST('/schemasFashion', {
        pluginconfigId: parseInt(id ? id : '0'),
        plugintemplateId: templateId,
      })
      if (schemaRes.filter) {
        setJsonContent(JSON.stringify(schemaRes))
      } else {
        setJsonContent(null)
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setJsonContent(null)
      setLoading(false)
    }
  }

  const getTemplates = async () => {
    try {
      setLoading(true)
      let templateRes = await POST('/plugintemplate/filter?take=1000', {})
      const newTemplates: TemplateResponseType[] = [
        {
          id: 0,
          name: 'Selecione um template',
          parameters: null,
          plugintypeId: 0,
          typeIntegration: 'others',
        },
      ]
      const plugincode = getPlugintypeIdByCode(loginInfo.plugintype)
      templateRes.data.forEach((template: TemplateResponseType) => {
        if (
          (template.plugintypeId === 1 || template.plugintypeId === plugincode) &&
          template.typeIntegration === 'pdv'
        )
          newTemplates.push({
            id: template.id,
            name: template.name,
            plugintypeId: template.plugintypeId,
            typeIntegration: template.typeIntegration,
            parameters: JSON.parse(template.parameters),
          })
      })
      setTemplates(newTemplates)
      setLoading(false)
      return newTemplates
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const changeTemplate = async (
    selectedId: number,
    configuration?: any,
    newTemplates?: TemplateResponseType[]
  ) => {
    console.log('changeTemplate chamada com:', {selectedId, configuration, newTemplates})
    setTemplateId(selectedId)
    if (selectedId !== 0) {
      await getDto(selectedId)
      let template
      if (templates.length === 0 && newTemplates) {
        template = newTemplates.find((templateFinded) => templateFinded.id === selectedId)
      } else {
        template = templates.find((templateFinded) => templateFinded.id === selectedId)
      }
      console.log('Template encontrado:', template)
      console.log('Configuração recebida:', configuration)

      let newInputs: (ConfigInputsType | undefined)[] = Object.entries(
        template?.parameters.config
      ).map((configInput) => {
        if (
          configInput[0] !== undefined &&
          configInput[1] !== undefined &&
          typeof configInput[1] === 'string'
        ) {
          let label = configInput[1]

          // Verifica se contém "&" na string
          if (configInput[1].includes('&')) {
            label = configInput[1].split('&')[0].trim()
          }

          const input: ConfigInputsType = {
            name: configInput[0],
            label: label,
            value:
              configuration && configuration[configInput[0]] ? configuration[configInput[0]] : '',
          }
          console.log(`Campo criado: ${configInput[0]} = ${input.value}`)
          return input
        }
        return undefined
      })

      if (loginInfo.plugintype === 'food' && selectedId === 101) {
        newInputs = newInputs.filter((input: any) => (input.name !== 'type' ? true : false))
      }

      console.log('Inputs finais:', newInputs)
      setConfigInputs(newInputs)
    }
  }

  const editIntegration = async () => {
    if (templateId) {
      const template = templates.find((templateFinded) => templateFinded.id === templateId)
      let integrationContent: any = {}

      console.log('=== DEBUG EDITINTEGRATION ===')
      console.log('Template ID:', templateId)
      console.log('Template encontrado:', template)
      console.log('Config inputs atuais:', configInputs)
      console.log('Nome da integração:', name)

      // Usar os valores do estado configInputs em vez de buscar do DOM
      configInputs.forEach((configInput) => {
        if (configInput?.name) {
          if (
            loginInfo.plugintype === 'food' &&
            templateId === 101 &&
            configInput.name === 'type'
          ) {
            integrationContent[configInput.name] = '1'
          } else {
            integrationContent[configInput.name] = configInput.value || ''
          }
          console.log(`Campo: ${configInput.name} = ${integrationContent[configInput.name]}`)
        }
      })

      console.log('Integration content final:', integrationContent)

      const pluginType = template?.plugintypeId
      try {
        if (!name || !templateId || !pluginType) {
          console.log('Validação falhou:', {name, templateId, pluginType})
          Swal.fire({
            icon: 'error',
            title: 'Campos faltantes',
            text: 'Verifique se preencheu todos os campos!',
          })
        } else {
          setLoading(true)

          const requestData = {
            plugintypeId:
              template && template.plugintypeId
                ? template.plugintypeId
                : getPlugintypeIdByCode(loginInfo.plugintype),
            plugintemplateId: templateId,
            name: name,
            content: integrationContent,
          }

          console.log('Dados enviados para a API:', requestData)

          const integrationRes = await PUT(`/pluginconfig/${id}`, requestData)

          console.log('Resposta da API:', integrationRes)

          setLoading(false)
          if (integrationRes.success === true) {
            Swal.fire({
              icon: 'success',
              title: 'Integração alterada',
              text: 'Edição realizada com sucesso!',
            }).then(() => navigate('/pluginconfig/pdv'))
          } else {
            console.log('Erro da API:', integrationRes)
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: integrationRes.message || 'Erro ao alterar integração!',
            })
          }
        }
      } catch (e) {
        setLoading(false)
        console.log('Erro na requisição:', e)
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao alterar integração!',
        })
      }
    } else {
      console.log('Template ID não encontrado')
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Template não selecionado!',
      })
    }
  }

  useEffect(() => {
    getIntegration()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{`${i18n.t(
                  `general.edit`
                )} ${i18n.t(`integration.PDV`)}`}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`general.save_changes_edit`)}
                </span>
              </h3>
            </div>
            <div className='card-body border-bottom'>
              <div className='d-flex justify-content-between align-items-center'>
                <div className='me-5 flex-grow-1'>
                  <Input
                    inputAttr={{
                      type: 'text',
                    }}
                    placeholder={i18n.t(`integration.integration_name`)}
                    label={i18n.t(`integration.integration_name`)}
                    change={(value: string) => setName(value)}
                    value={name}
                  />
                </div>
                <div className='flex-grow-1'>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    label={i18n.t(`integration.type_of_integration`)}
                    change={async (value: string) => {
                      await changeTemplate(parseInt(value))
                    }}
                    options={templates.map((template) => ({
                      value: template.id,
                      select: template.name,
                    }))}
                    value={templateId}
                  />
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
                {configInputs.map((config) => (
                  <div style={{flex: '40%'}} key={config?.name}>
                    <Input
                      inputAttr={{
                        type: 'text',
                      }}
                      placeholder={config?.label}
                      label={config?.label}
                      name={config?.name}
                      value={config?.value || ''}
                      change={(value: string) => {
                        // Atualizar o valor no estado quando o usuário digitar
                        setConfigInputs((prevInputs) =>
                          prevInputs.map((input) => {
                            if (input?.name === config?.name) {
                              return {...input, value: value} as ConfigInputsType
                            }
                            return input
                          })
                        )
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className='d-flex w-100'>
              <div className='col-6 d-flex justify-content-start'>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate(-1)}
                  btnClass='fw-bolder m-9'
                />
              </div>
              <div className='col-6  d-flex justify-content-end'>
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => editIntegration()}
                  btnClass='fw-bolder m-9'
                />
              </div>
            </div>
          </div>
          {jsonContent && (
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`integration.example`)}
                  </span>
                </h3>
              </div>
              <div className='card-body border-bottom'>
                <div
                  className='d-flex'
                  style={{backgroundColor: 'black', overflowY: 'scroll', height: '40em'}}
                >
                  <JsonFormatter json={jsonContent} tabWith={4} jsonStyle={jsonStyle} />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

const EditarPdv: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`integration.PDV`), path: 'pluginconfig/pdv', isActive: true},
          {title: i18n.t(`general.edit`), path: 'pluginconfig/pdv/edit', isActive: true},
        ]}
      >
        {`${i18n.t(`general.edit`)} ${i18n.t(`integration.PDV`)}`}
      </PageTitle>
      <EditarPdvContent />
    </>
  )
}

export {EditarPdv}
